<template>
  <v-layout>
    <v-flex v-if="worksiteLoaded" class="mt-2">
      <InternalNotesWidget
        v-if="user.managerOrHigher"
        entityName="Worksite"
        :entityId="worksite.id"
      />
      <v-layout>
        <v-flex class="px-2">
          <h1 class="display-1">{{ worksite.name }}</h1>
          <div class="mb-3">
            <p class="mb-0 subheading">
              {{ worksite.streetAddress }}<br/>
              {{ worksite.city }}, {{ worksite.state }} {{ worksite.zip }}
            </p>

            <div v-if="worksite.mapEmbed">
              <v-dialog v-model="mapDialog">
                <a slot='activator' href="#">Show map</a>
                <v-card class="text-xs-center">
                  <v-card-text>
                    <div v-html="worksite.mapEmbed"></div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </div>

          <p v-if="worksite.phone">
            <span class="all-caps body-2">Phone: </span>{{ worksite.phone }}
          </p>
          <!--
          <v-img v-if="location.officeImageUrl" class="mb-3":src="location.officeImageUrl"></v-img>
          -->
          <ul class='info-listing mb-3'>
            <li v-if="worksite.scope"><span>Scope: </span>{{ worksite.scope }}</li>
            <li v-if="worksite.managementSoftware"><span>Hospital Management Software: </span>{{ worksite.managementSoftware }}</li>
            <li v-if="worksite.dvmCount"><span>DVMs: </span>{{ worksite.dvmCount }}</li>
            <li v-if="worksite.timeclockworksite"><span>worksite of Timeclock: </span>{{ worksite.timeclockworksite }}</li>
            <li v-if="worksite.uniformRequirements"><span>Uniform Requirements: </span>{{ worksite.uniformRequirements }}</li>
            <li v-if="worksite.website"><span>Website: </span><a target="_blank" :href="worksite.website">{{ worksite.website }}</a></li>
          </ul>
          <div v-if="worksite.overview">
            <span class="all-caps font-weight-bold">Overview: </span><p style="white-space: pre-wrap;">{{ worksite.overview }}</p>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-else>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
  },
  created () {
    this.setUp ();
  },
  watch: {
  },
  data: function () {
    return {
      worksiteLoaded: false,
      worksite: null,
      mapDialog: false,
    }
  },
  methods: {
    setUp () {
      this.getWorksite(this.$route.params.worksiteId);
    },
    getWorksite (worksiteId) {
      console.log(worksiteId);
      this.$store.dispatch('worksites/getWorksite', worksiteId)
      .then(r => {
        this.worksite = r
      })
      .finally(r => {
        this.worksiteLoaded = true
      })
    }
  },
}
</script>

<style scoped>
</style>
